var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',_vm._l((_vm.internetAuctions),function(auction,index){return _c(auction.type,{key:index,tag:"Component",attrs:{"auction":auction}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d4c3006","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/employees_orders_panel/components/table/main_table_body.vue
// module id = 809
// module chunks = 0 1 2 3 4 5 6 7 8 10 20 22